import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: {
  hlsLocation: string | null;
  videoLocation: string | null;
  isMultiVideoStreaming: boolean;
} = {
  hlsLocation: null,
  videoLocation: null,
  isMultiVideoStreaming: false,
};

export const videoSlice = createSlice({
  name: 'videoSlice',
  initialState,
  reducers: {
    setHLSlocation: (state, action: PayloadAction<string | null>) => {
      state.hlsLocation = action.payload;
    },
    setVideoLocation: (state, action: PayloadAction<string | null>) => {
      state.videoLocation = action.payload;
    },
    setIsMultiVideoStreaming: (state, action: PayloadAction<boolean>) => {
      state.isMultiVideoStreaming = action.payload;
    },
  },
});

export const videoSliceActions = videoSlice.actions;
